export default "__VITE_ASSET__CF87o_fN__"